import React from "react";
import { Box } from "@mui/material";
import { Button } from "react-bootstrap";
import { useFontSizeStore } from "../../../stores/zustand";

export default function FontController() {
  const { increaseFont, decreaseFont, resetFont } = useFontSizeStore();

  return (
    <Box sx={{ display: "flex", justifyContent: "center", gap: 5, my: 2 }}>
      <Button onClick={decreaseFont}> A - </Button>
      <Button onClick={resetFont}> A </Button>
      <Button onClick={increaseFont}> A + </Button>
    </Box>
  );
}
